document.addEventListener( 'DOMContentLoaded', function () {
    // Dynamically select fields based on the "shipping_postcode_*" class
    const postcodeDivs = document.querySelectorAll( 'form [class*="shipping-postcode-"]' );
    const fields = {};

    // Push all the fields into an object with custom keys
    postcodeDivs.forEach( ( node ) => {
        // Extract the class after 'shipping-postcode-'
        const className = Array.from( node.classList ).find( cls => cls.startsWith( 'shipping-postcode-' ) );
        if ( className ) {
            const key = className.replace( 'shipping-postcode-', '' ); // Remove 'shipping_postcode_' prefix
            fields[key] = node; // Add the field to the object
        }
    });

    // Assign specific fields from the dynamically created variables
    const sourcefieldShippingCity = fields['city'];
    const sourcefieldShippingCountry = fields['country'];
    const sourcefieldShippingHouseNumber = fields['house-number'];
    const sourcefieldShippingPostcode = fields['postcode'];
    const sourcefieldShippingStreet = fields['street'];

    // Check if all necessary fields exist
    if ( sourcefieldShippingCity && sourcefieldShippingStreet && sourcefieldShippingHouseNumber && sourcefieldShippingCountry && sourcefieldShippingPostcode ) {
        let debounceTimeout;

        // Function to update the target fields (street and city) based on postcode and house number input
        const updateTargetField = () => {

            // Trim input values from postcode and house number fields
            const postcodeValue = sourcefieldShippingPostcode.value.trim();
            const houseNumberValue = sourcefieldShippingHouseNumber.value.trim();

            // Clear any existing debounce timeout
            clearTimeout( debounceTimeout );

            // Set a new timeout for 100ms to avoid frequent API calls
            debounceTimeout = setTimeout( async () => {

                // If both postcode and house number have values
                if ( postcodeValue && houseNumberValue ) {

                    // Fetch address details using an external API
                    var address = await autoFillAddress( postcodeValue, houseNumberValue );
                    if ( address ) {

                        // Update the street and city fields with API response
                        sourcefieldShippingStreet.value = address?.street;
                        sourcefieldShippingCity.value = address?.city;
                    }
                }
            }, 100 );
        };

        // Attach the input event listener to relevant fields
        sourcefieldShippingPostcode.addEventListener( 'input', updateTargetField );
        sourcefieldShippingHouseNumber.addEventListener( 'input', updateTargetField );
    }
} );